/*
 * The history of a chat of «Задать вопрос» (Quint ask_chat Чт1): the whole chat goes with a question, capped only by a
 * ceiling in characters — when it does not fit, the newest turns stay. The widget owns the history (it is the chat in its
 * panel); the service reads what it was sent with the same ceiling and does not cut it by the number of turns.
 */
export interface HistoryTurn {
  question: string;
  answer: string;
}

/** Characters (question + answer) of the history one question carries. */
export const HISTORY_CHARS = 16_000;

/** The newest turns that fit `max` characters, in the order they were asked. */
export function fitHistory<T extends HistoryTurn>(turns: T[], max: number = HISTORY_CHARS): T[] {
  let total = 0;
  let from = turns.length;
  while (from > 0) {
    const size = turns[from - 1].question.length + turns[from - 1].answer.length;
    if (total + size > max) break;
    total += size;
    from -= 1;
  }
  return turns.slice(from);
}
